import { AppointmentStatus } from '@lib/core/models/visit.interface';

import { PrescriptionPlanningStatus } from '../models/prescription.interface';

export function getAllowedPlanningStatuses(currentStatus: PrescriptionPlanningStatus | null | undefined): PrescriptionPlanningStatus[] {
  switch (currentStatus) {
    case PrescriptionPlanningStatus.Planned:
      return [
        PrescriptionPlanningStatus.Planned,
        PrescriptionPlanningStatus.Completed,
        PrescriptionPlanningStatus.Cancelled,
        PrescriptionPlanningStatus.NoShow,
      ];
    case PrescriptionPlanningStatus.Completed:
      return [PrescriptionPlanningStatus.Completed, PrescriptionPlanningStatus.NoShow];
    default:
      return currentStatus ? [currentStatus] : [];
  }
}

export function mapPlanningToAppointmentStatus(planningStatus: PrescriptionPlanningStatus): AppointmentStatus | null {
  switch (planningStatus) {
    case PrescriptionPlanningStatus.NoShow:
      return AppointmentStatus.NoShow;
    case PrescriptionPlanningStatus.Completed:
      return AppointmentStatus.Completed;
    default:
      return null;
  }
}
